/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Zwischenbericht (Zwischenbericht)
 * 
 * 401130001 = Abschlussbericht (Abschlussbericht)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceTypprojektbericht {
 Zwischenbericht = 401130000,
 Abschlussbericht = 401130001
}

marker([
    "Enum.GlobalEnumsAceTypprojektbericht.Zwischenbericht",
    "Enum.GlobalEnumsAceTypprojektbericht.Abschlussbericht"
]);

export namespace GlobalEnumsAceTypprojektbericht
{
    class DataSets
    {
        static GlobalEnumsAceTypprojektberichtDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Zwischenbericht", 401130000, "Zwischenbericht"),
            new EnumValue("Abschlussbericht", 401130001, "Abschlussbericht"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceTypprojektberichtDataSet;
    }
}
